import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Tab } from '@mui/material'
import NotLogged from 'components/NotLogged'
import { useQuery } from 'hooks/useQuery'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { axiosInstance } from 'services/api'
import UserStore from 'services/userLocalStorage'
import { getPreferences } from 'store/reducers/preference.thunks'
import AssessmentPortal from 'views/Assessment/AssessmentPortal'
import IncidentsSelfService from 'views/IncidentsSelfService'
import RequestSelfService from 'views/RequestSelfService'
import AssetTreatmentPortal from '../AssetTreatment/AssetTreatmentPortal'
import MyAssessmentsPortal from 'views/MyAssessments/MyAssessments'

function SelfService({ match, ...props }) {
    const { t } = useTranslation()
    const { auth, geral = {} } = useSelector((store) => store)
    const reduxDispatch = useDispatch()
    const [value, setValue] = React.useState('0');
    const [canCreateDiagnosis, setCanCreateDiagnosis] = React.useState(false)
    const [canCreateAssets, setCanCreateAssets] = React.useState(false)
    const [canCreateIncidents, setCanCreateIncidents] = React.useState(false)
    const [canCreateRequests, setCanCreateRequests] = React.useState(false)
    const query = useQuery();
    
   let token = ''
   if(auth.signinToken == null){
       token = UserStore.getToken()
    }else{
        token = auth.signinToken
    }
    
    React.useEffect(() => {
        setValue(query.get("tab") ?? '0');
    
        if (auth.isAuthenticated && geral.language) {
          reduxDispatch(getPreferences(geral.language))
        }
      }, [reduxDispatch, geral.language])

    React.useEffect(() =>{
      loadPermission()
    }, [])

    async function loadPermission() {
    const requestOptions = {
      method: 'GET',
      url: `/selfservice/${window.endPoints.api.portalID}/hasPermission`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    }

    axiosInstance(requestOptions)
      .then((res) => {
        setCanCreateDiagnosis(res.data.canCreateDiagnosis)
        setCanCreateAssets(res.data.canCreateAsset)
        setCanCreateIncidents(res.data.canCreateIncidents)
        setCanCreateRequests(res.data.canCreateRequests)
      })
      .catch((err) => {
        console.log(err)
        setCanCreateDiagnosis(false)
        setCanCreateAssets(false)
        setCanCreateIncidents(false)
        setCanCreateRequests(false)
      })
  }

    const handleChangeTab = (event, newValue) => {
      setValue(newValue);
    };
    
    if (!auth.isAuthenticated) {
        return (
          <section>
            <NotLogged />
          </section>
        )
    }

    return (

        <section>
          <header className="pvt-content-header custom">
            <h1 className="pvt-content-title custom">{t('routes.label.selfService')}</h1>
            <p className="pvt-content-desc custom">
              {t('selfService.content')}
            </p>
          </header>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChangeTab} aria-label="Self Service">
                  {canCreateAssets ?
                  <Tab default label={t('label.self.service.asset.create')} value="0" />
                  : null}
                  {canCreateDiagnosis ?
                  <Tab label={t('label.self.service.diagnosis.create')} value="1" />
                  : null}
                  {canCreateIncidents ?
                  <Tab label={t('label.self.service.incident.label')} value="2" />
                  : null}
                  {canCreateRequests ?
                  <Tab label={t('label.self.service.request.label')} value="3" />
                  : null}
                  <Tab label={t('label.self.service.my.assessments.label')} value="4" />
                </TabList>
              </Box>
              {canCreateAssets && (
                <TabPanel value='0'>
                  <AssetTreatmentPortal />
                </TabPanel>
              )}
              {canCreateDiagnosis && (
                <TabPanel value='1'>
                  <AssessmentPortal />
                </TabPanel>
              )}
              {canCreateIncidents && (
                <TabPanel value='2'>
                  <IncidentsSelfService />
                </TabPanel>
              )}
              {canCreateRequests && (
                <TabPanel value='3'>
                  <RequestSelfService />
                </TabPanel>
              )}
              <TabPanel value="4">
                <MyAssessmentsPortal />
              </TabPanel>    
            </TabContext>
          </Box>
        </section>
      )

      
}

export default SelfService
